'use client';

import { Guides } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { cn } from '@insta-club/utilities';
import Image from 'next/image';
import { memo, useState } from 'react';
import ReelsDescription from '../reels/reels-description';
import CustomVideo from './custom-video';

interface Props {
    guide: Guides;
}

const GuideVideo: React.FC<Props> = ({ guide }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className='relative h-full w-full cursor-pointer bg-black'>
            <div
                onClick={() => setExpanded(false)}
                className={cn('absolute inset-x-0 bottom-0 z-30 bg-gradient-to-t from-black to-transparent', {
                    'pointer-events-auto top-0': expanded,
                    'pointer-events-none h-1/3': !expanded
                })}
            />

            <MemoizedGuideVideoContent guide={guide} />

            <div className='absolute inset-x-0 bottom-8 z-50 flex flex-col gap-2 px-4 text-white'>
                <div className='flex items-center gap-3'>
                    <div className='h-9 w-9 rounded-full border-2 border-gray-400 bg-white p-1'>
                        <Image alt={t('insta_club')} src='/icons/logo.png' width={36} height={36} />
                    </div>
                    <span>{t('insta_club')}</span>
                </div>
                {guide.description ? (
                    <ReelsDescription text={guide.description} isExpanded={expanded} onExpanded={setExpanded} />
                ) : null}
            </div>
        </div>
    );
};

export default GuideVideo;

interface VideoContentProps {
    guide: Guides;
}

const GuideVideoContent: React.FC<VideoContentProps> = ({ guide }) => {
    if (guide.video) {
        return <CustomVideo hlsUrl={guide.video?.hls} mp4Url={guide.video?.url} disableProgress={false} showProgress />;
    }

    if (guide.iframe) {
        return (
            <div className='flex h-full w-full items-center justify-center'>
                <div className='w-full overflow-hidden'>
                    <div dangerouslySetInnerHTML={{ __html: guide.iframe }} />
                </div>
            </div>
        );
    }
    return null;
};

const MemoizedGuideVideoContent = memo(GuideVideoContent);

